import { useServiceHistoryCdkQuery } from '../../../api';
import styles from './styles.module.scss';
import { InlineSvg } from 'components/svg';
import { FC, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ButtonWithIcon } from 'shared';
import { formatDate } from 'utils/formats';

type CdkDetailsModalProps = {
  serviceHistoryId: string;
  onClose: () => void;
};

const CdkDetailsModal: FC<CdkDetailsModalProps> = ({ serviceHistoryId, onClose }) => {
  return (
    <>
      <div className="modal fade show d-block" role="dialog" tabIndex={-1} aria-modal="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">CDK Details - {serviceHistoryId}</h5>
              <div
                className="btn btn-icon btn-sm btn-active-icon-primary"
                onClick={onClose}
                style={{ cursor: 'pointer' }}
              >
                <InlineSvg path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
              </div>
            </div>
            <div className="modal-body">
              <p>Details for CDK ID: {serviceHistoryId}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

type Props = {
  serviceHistoryId?: number | null;
};

export const CDKVehicleHistorySection: FC<Props> = ({ serviceHistoryId }) => {
  const [detailsCdkId, setDetailsCdkId] = useState<string | null>(null);

  const { data, isFetching, refetch } = useServiceHistoryCdkQuery(
    { serviceHistoryId: serviceHistoryId ?? 0 },
    { enabled: !!serviceHistoryId }
  );

  const renderSkeletonRows = () =>
    Array.from({ length: 5 }, (_, index) => (
      <tr key={`skeleton-${index}`}>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} width={60} />
        </td>
      </tr>
    ));

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>CDK Service History</div>
        {!data && (
          <div className={styles.emptyContainer}>
            <div className={styles.emptyTitle}>Service History not found</div>
            <div>
              <ButtonWithIcon
                iconPath="/media/icons/custom/zoom_1.svg"
                onClick={() => refetch()}
                isLoading={isFetching}
              >
                Look Up CDK Service History
              </ButtonWithIcon>
            </div>
          </div>
        )}

        {data && (
          <div>
            <div className={styles.createdInfo}>
              <div>
                Last Look Up - {data.createdInfo?.creationDate ? formatDate(data.createdInfo?.creationDate) : '-'} by{' '}
                {data.createdInfo?.name ?? '-'}
              </div>
              <ButtonWithIcon
                iconPath="/media/icons/custom/zoom_1.svg"
                btnStyle="light-primary"
                onClick={() => refetch()}
                isLoading={isFetching}
              >
                Update
              </ButtonWithIcon>
            </div>

            <div className={styles.scrollContainer}>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>CDK Id</th>
                      <th>Service Date</th>
                      <th>Description</th>
                      <th>Mileage</th>
                      <th>WorkshopName</th>
                      <th>CDK Repair Order Id</th>
                      <th>Invoice Number</th>
                      <th>Net Price</th>
                      <th>Gross Price</th>
                      <th>Discount</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {isFetching
                      ? renderSkeletonRows()
                      : data.values?.map((d) => (
                          <tr key={d.cdkId}>
                            <td data-label="CDK Id">{d.cdkId}</td>
                            <td data-label="Service Date">{d.serviceDate ? formatDate(d.serviceDate) : '-'}</td>
                            <td data-label="Description">{d.description}</td>
                            <td data-label="Mileage">{d.mileage}</td>
                            <td data-label="Workshop">{d.workshopName}</td>
                            <td data-label="Repair Order">{d.cdkRepairOrderId}</td>
                            <td data-label="Invoice">{d.invoiceNumber}</td>
                            <td data-label="Net Price">{d.netPrice}</td>
                            <td data-label="Gross Price">{d.grossPrice}</td>
                            <td data-label="Discount">{d.discount}</td>
                            <td>
                              <ButtonWithIcon
                                btnStyle="light-secondary"
                                onClick={() => setDetailsCdkId(d.cdkId ?? null)}
                              >
                                Details
                              </ButtonWithIcon>
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
      {detailsCdkId && <CdkDetailsModal serviceHistoryId={detailsCdkId} onClose={() => setDetailsCdkId(null)} />}
    </>
  );
};
